import { TextLayer } from '@deck.gl/layers';
import { useOutletContext } from 'react-router-dom';

import Map from '@App/components/Map/Map';
import Question3Form from '@App/pages/Tablet/Question3/Question3Form';
import attractionData from '@App/components/Map/data/attraction-data';
import {
  getCount, getFeatureCoordinates, getFeatureName, getFeatureValue,
} from '../question.utils';

const QUESTION_ID = 'question3';

function buildQuestionData(answerCount) {
  return attractionData.features
    .filter(feature => feature.properties?.category === 'city')
    .map(feature => ({
      coordinates: getFeatureCoordinates(feature),
      name: getFeatureName(feature),
      count: getCount(answerCount, [
        getFeatureValue(feature),
        getFeatureName(feature),
      ]),
    }))
}

function getQuestionLayers({ data }) {
  const chosenCities = data.filter(city => city.count > 0);
  const unchosenCities = data.filter(city => city.count === 0);

  return [new TextLayer({
    id: 'question-3-attractions',
    data: chosenCities,
    getColor: [255, 226, 146, 235],
    getPosition: item => item.coordinates,
    getSize: item => 12 + Math.min(item.count, 8),
    getText: item => item.name,
    getPixelOffset: [0, -12],
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'bottom',
    outlineColor: [20, 31, 46, 255],
    outlineWidth: 3,
    pickable: false,
  }), new TextLayer({
    id: 'question-3-unchosen-cities',
    data: unchosenCities,
    getColor: [255, 255, 255, 180],
    getPosition: item => item.coordinates,
    getSize: 6,
    getText: item => item.name,
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'center',
    outlineColor: [20, 31, 46, 220],
    outlineWidth: 2,
    pickable: false,
  })];
}

function Question3(props) {
  const { withInputFields = false, ...visualizationProps } = props;
  const { lastAnswer: contextLastAnswer } = useOutletContext() || {};
  const lastAnswer = props.lastAnswer ?? contextLastAnswer;
  const focusCoordinates = lastAnswer?.questionId === QUESTION_ID
    ? lastAnswer.answer?.coordinates || null
    : null;

  return (
    <Map
      questionId={QUESTION_ID}
      buildData={buildQuestionData}
      getLayers={getQuestionLayers}
      autoRotate
      focusCoordinates={focusCoordinates}
      returnToOverview
      {...visualizationProps}
    >
      {withInputFields && <Question3Form />}
    </Map>
  );
}

export default Question3;
